import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, CATEGORIES } from "@/lib/api";

const TABS = [["all", "Wszystko"], ["news", "Newsy"], ["changelog", "Changelog"], ["event", "Eventy"]];

export default function NewsPanel() {
  const [news, setNews] = useState([]);
  const [tab, setTab] = useState("all");
  const [open, setOpen] = useState(null);

  useEffect(() => { api.get("/news").then((r) => setNews(r.data)); }, []);
  const list = tab === "all" ? news : news.filter((n) => n.category === tab);

  return (
    <div className="flex flex-col min-h-0 flex-1">
      <div className="flex gap-5 border-b border-white/10 mb-3">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`news-tab-${k}`}
            className={`pb-2 text-xs uppercase tracking-[0.2em] transition-colors border-b-2 -mb-px ${tab === k ? "border-amber-400 text-amber-200" : "border-transparent text-slate-500 hover:text-slate-300"}`}>
            {l}
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto pr-1 space-y-2 launcher-scroll" data-testid="news-list">
        <AnimatePresence mode="popLayout">
          {list.map((n, i) => (
            <motion.button key={n.id} layout initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0, transition: { delay: i * 0.04 } }} exit={{ opacity: 0 }}
              onClick={() => setOpen(n)} data-testid={`news-item-${n.id}`}
              className="w-full text-left p-3 rounded-md bg-black/40 border border-amber-500/10 hover:border-amber-500/40 hover:bg-black/60 transition-colors group">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-[10px] uppercase tracking-widest text-amber-500/90">{CATEGORIES[n.category] || n.category}</span>
                <span className="text-[10px] text-slate-600">{new Date(n.created_at).toLocaleDateString("pl-PL")}</span>
              </div>
              <div className="text-sm font-semibold text-slate-100 group-hover:text-amber-100 transition-colors">{n.title}</div>
              <div className="text-xs text-slate-400 line-clamp-1">{n.content}</div>
            </motion.button>
          ))}
        </AnimatePresence>
        {!list.length && <p className="text-xs text-slate-500 py-6" data-testid="news-empty">Brak wpisów.</p>}
      </div>
      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent className="bg-[#11141c] border-amber-500/30 text-slate-200" data-testid="news-detail-modal">
          <DialogHeader><DialogTitle className="font-display text-amber-200 tracking-wide">{open?.title}</DialogTitle></DialogHeader>
          <p className="text-sm whitespace-pre-wrap text-slate-300 leading-relaxed">{open?.content}</p>
        </DialogContent>
      </Dialog>
    </div>
  );
}
